import React from 'react';
import { ResponsiveTimeRange } from '@nivo/calendar'
import { useTheme, Box, Typography } from '@mui/material';

const TimeRangeChart = ({ 
  data = [], 
  fromDate,
  toDate,
  title = "",
  digit = 0,
  topOffSet = 0,
  bottomOffSet = 0,
  itemWidthOffSet = 0,
  translateXOffSet = 0,
  translateYOffSet = 0,
}) => {
  const theme = useTheme();
  const primaryDark = theme.palette.primary.dark;
  const neutralDark = theme.palette.neutral.dark;
  const textPrimaryColor = theme.palette.text.primary;
  
  if (!data || data.length === 0 || !Array.isArray(data)) {
    return (
      <Box p={1} sx={{ height: '100%', width: '100%' }}>        
        <Typography>Nothing to display</Typography>
      </Box>
    );
  }
  

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      gap={1} 
      sx={{ height: '100%', width: '100%' }}
    >
      {title && 
        <Typography 
          variant="h6" 
          align="center"
        >
          {title}
        </Typography>
      }

      <ResponsiveTimeRange
        data={data}     
        from={fromDate}
        to={toDate}        
        margin={{ 
          top: 35 + (topOffSet || 0),
          right: 40, 
          bottom: 125 + (bottomOffSet || 0), 
          left: 40 
        }}
        firstWeekday="monday"
        weekdayTicks={[0, 1, 2, 3, 4, 5, 6]}
        monthLegendOffset={12}
        emptyColor="#eeeeee"
        colors={[ '#f50505', '#f47560', '#f5d105', '#e8c1a0', '#97e3d5', '#61cdbb', '#05d9f5', '#0545f5' ]}
        // minValue="auto"
        dayBorderWidth={2}
        dayBorderColor="#ffffff"
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: -40 + translateXOffSet, 
            translateY: -110 + translateYOffSet,
            itemsSpacing: 0,            
            itemWidth: 100 + itemWidthOffSet,
            itemHeight: 18,
            itemDirection: 'left-to-right',            
            itemTextColor: textPrimaryColor,
            symbolSize: 12,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: textPrimaryColor,
                }
              }
            ]
          }
        ]}
        theme={{
          axis: {
            domain: {
              line: {
                stroke: neutralDark,
              },
            },
            legend: {
              text: {
                fill: textPrimaryColor,
              },
            },
            ticks: {
              line: {
                stroke: neutralDark,
                strokeWidth: 1,
              },
              text: {
                fill: textPrimaryColor,
              },
            },
          },          
          legends: {
            text: {
              fill: textPrimaryColor,
            },
          }, 
          grid: {
            line: {
              stroke: neutralDark,
              strokeWidth: 0.5,
              strokeDasharray: '2 2'
            }
          },
          tooltip: {
            container: {
              background: theme.palette.neutral.light,
              color: theme.palette.text.primary,
              borderRadius: '4px',
              padding: '8px',
            },
          },
          labels: {
            text: {
              fill: textPrimaryColor,
              fontSize: '12px' 
            },
          },
          dots: {
            text: {
              fill: textPrimaryColor,
            },
          },
          totals: {
            text: {
              fill: primaryDark, 
              fontSize: '12px',
            },
          },
        }}      
      />
    </Box>
  );
};

export default TimeRangeChart;
